module.exports = __webpack_public_path__ + "static/media/logo-trevo-login.61e766cc.png";